import React, { useEffect, useRef } from "react";
import "./HeroRippleCanvas.css";

/** Bitmap size (logical px). */
export const HERO_RIPPLE_CANVAS_W = 1000;
export const HERO_RIPPLE_CANVAS_H = 380;

const HERO_RIPPLE_RX_MAX = 440;
const HERO_RIPPLE_RY_RATIO = 0.34;
const HERO_RIPPLE_COUNT = 5;
const HERO_RIPPLE_PHASE = 78;

/**
 * Animated perspective ripples (stroked ellipses), transparent background.
 * Drop under hero phone: <HeroRippleCanvas /> inside .banner_img.
 */
export default function HeroRippleCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return undefined;
    if (typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      return undefined;
    }

    const ctx = canvas.getContext("2d", { alpha: true });
    if (!ctx) return undefined;

    let t = 0;
    let raf = 0;
    let cancelled = false;

    const tick = () => {
      if (cancelled) return;
      const { width: w, height: h } = canvas;
      const cx = w / 2;
      const cy = h * 0.5;
      ctx.clearRect(0, 0, w, h);
      ctx.lineJoin = "round";

      const rings = [];
      for (let i = 0; i < HERO_RIPPLE_COUNT; i += 1) {
        const rx = (t * 1 + i * HERO_RIPPLE_PHASE) % (HERO_RIPPLE_RX_MAX + HERO_RIPPLE_PHASE);
        if (rx < 10) continue;
        rings.push(rx);
      }
      rings.sort((a, b) => b - a);

      for (const rx of rings) {
        const ry = Math.max(8, rx * HERO_RIPPLE_RY_RATIO);
        ctx.beginPath();
        ctx.ellipse(cx, cy, rx, ry, 0, 0, Math.PI * 2);
        ctx.strokeStyle = "#ffffff";
        ctx.lineWidth = Math.max(1.35, 2.35 - rx / 320);
        ctx.stroke();
      }

      t += 1;
      raf = requestAnimationFrame(tick);
    };

    raf = requestAnimationFrame(tick);
    return () => {
      cancelled = true;
      cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div className="hero-ripple-canvas-wrap" aria-hidden>
      <canvas
        ref={canvasRef}
        className="hero-ripple-canvas"
        width={HERO_RIPPLE_CANVAS_W}
        height={HERO_RIPPLE_CANVAS_H}
      />
    </div>
  );
}
